<template>
  <div class="base-radio">
    <input
      type="radio"
      :id="id"
      :value="value"
      :disabled="disabled"
      v-model="radioValue"
      :name="name"
    />
    <label
      :for="id"
      :class="labelClass"
      :style="labelStyle"
      v-html="label"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseRadio',

  props: {
    id: {
      type: [String, Number],
      required: true
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: ''
    },
    value: {
      type: [String, Number, Boolean],
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: [String, Number],
      default: ''
    },
    disabled: Boolean,
    labelStyle: String,
    labelClass: String
  },

  emits: ['update:modelValue'],

  computed: {
    radioValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/design/mainIncludes";

.base-radio {
  input {
    display: none;
  }

  label {
    padding-left: 32px;
    font-size: 15px;
    line-height: 26px;
    position: relative;
    cursor: pointer;
    display: block;

    &::before {
      content: "";
      position: absolute;
      display: inline-block;
      width: 24px;
      height: 24px;
      left: 0;
      top: 0;
      border-radius: 50%;
      border: 1px solid $grey-4;
      background: #fff;
      transition: all 0.2s;
    }

    &::after {
      content: "";
      position: absolute;
      display: none;
      width: 12px;
      height: 12px;
      left: 6px;
      top: 6px;
      border-radius: 50%;
      background: #009440;
      transition: all 0.2s;
    }

    :deep a {
      font-size: inherit;
      font-weight: 500;
      color: $green-5;
    }
  }

  input:checked + label::before {
    border-color: #009440;
  }

  input:checked + label::after {
    display: block;
  }

  input:disabled + label {
    cursor: not-allowed;
    opacity: 0.6;
  }
}
</style>